import { createApp } from 'vue'
import { createPinia } from 'pinia'
import App from './App.vue'
import router from './router'
import './assets/main.css' // Tailwind CSS
import.meta.env
// Import global components
import AppButton from './components/ui/AppButton.vue'
import AppLoading from './components/ui/AppLoading.vue'
import AppAlert from './components/ui/AppAlert.vue'
import AppPagination from './components/ui/AppPagination.vue'
import ThemeToggle from './components/ui/ThemeToggle.vue'
import 'sweetalert2/dist/sweetalert2.min.css';
import { useAuthStore } from './stores/auth';


const currentVersion = import.meta.env.VITE_APP_VERSION || '1.0.0'
const storedVersion = localStorage.getItem('app-version')

if (storedVersion && storedVersion !== currentVersion) {
    localStorage.setItem('app-version', currentVersion)
    window.location.reload()
} else if (!storedVersion) {
    localStorage.setItem('app-version', currentVersion)
}


// Create app
const app = createApp(App)

// Register global components
app.component('AppButton', AppButton)
app.component('AppLoading', AppLoading)
app.component('AppAlert', AppAlert)
app.component('AppPagination', AppPagination)
app.component('ThemeToggle', ThemeToggle)

// Use plugins
app.use(createPinia())
app.use(router)
// Initialize auth store
const authStore = useAuthStore();
authStore.initAuth();

// Mount app
app.mount('#app')